import { render, staticRenderFns } from "./ShakenShohiyou.vue?vue&type=template&id=5d49e33c&scoped=true&"
import script from "./ShakenShohiyou.vue?vue&type=script&lang=ts&"
export * from "./ShakenShohiyou.vue?vue&type=script&lang=ts&"
import style0 from "./ShakenShohiyou.vue?vue&type=style&index=0&id=5d49e33c&lang=scss&scoped=true&"
import style1 from "./ShakenShohiyou.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d49e33c",
  null
  
)

component.options.__file = "ShakenShohiyou.vue"
export default component.exports